/** Detect video media URLs stored on R2 / CDN (extension-based). */
export function isVideoUrl(url: string | null | undefined): boolean {
  if (!url) return false;
  return /\.(mp4|webm|mov|ogg)(\?|#|$)/i.test(url);
}
